import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'enum' })
export class EnumPipe implements PipeTransform {
    transform(value, args: string[]): any {
        let keys = [];
        for (var enumMember in value) {
            if (!isNaN(parseInt(enumMember, 10))) {
                keys.push({ value: +enumMember, name: value[enumMember] });
            }
        }
        return keys;
    }
}